module.exports = __webpack_public_path__ + "047734ec915414a5cb5ac9bab08feced.png";